import moment from 'moment'

const DEFAULT_USER_LANGUAGE = 'en'

export const browserLanguage = () => {
  const { language } = navigator || {}

  return language || DEFAULT_USER_LANGUAGE
}

// https://momentjs.com/docs/#/i18n/locale-data/ for list of formats
export const localeLongDateFormat = format => {
  return moment()
    .locale(browserLanguage())
    .localeData()
    .longDateFormat(format)
}
